const getUrl = () => {
  return new URL(window.location.href);
};

export const getSearchParams = () => {
  return new URLSearchParams(window.location.search);
};

export const setSearchParamValue = (param: string, value: string) => {
  const url = getUrl();

  url.searchParams.set(`${param}`, value);

  return url;
};

export const setSearchParamTrue = (param: string) => {
  const url = getUrl();

  url.searchParams.set(`${param}`, 'true');

  return url;
};

export const hasSearchParam = (...params: string[]) => {
  const searchParams = getSearchParams();

  return params.some(param => searchParams.has(param));
};

export const deleteSearchParam = (...params: string[]) => {
  const url = getUrl();

  params.forEach(param => url.searchParams.delete(param));

  return url;
};

export const getParam = (param: string) => {
  return getSearchParams().get(param);
};

export const navigateReplace = (url: URL) => {
  window.history.replaceState(undefined, '', url);
};

export const setURLParams = (paramName: string, paramValue: string) => {
  const updatedValue = setSearchParamValue(paramName, paramValue);
  navigateReplace(updatedValue);
};
